import Transformer from './../transformer'
import NotificationTransformer from './notification'

export default class NotificationSinisterTransformer extends Transformer {
  static fetch(notification) {
    let data = NotificationTransformer.fetch(notification)
    data.content = notification.data.content
    return data
  }
}


// WEBPACK FOOTER //
// ./src/transformers/notification/customNotification.js